export const enTranslations = {
  common: {
    login: "Login",
    email: "Email",
    password: "Password",
    loading: "Loading...",
    cancel: "Cancel",
    submit: "Submit",
    delete: "Delete",
    close: "Close",
    copy: "Copy",
    copied: "Copied!",
    status: "Status",
    active: "Active",
    fulfilled: "Fulfilled",
    expired: "Expired",
    deleting: "Deleting...",
    creating: "Creating...",
    updating: "Updating...",
    actions: "Actions",
    name: "Name",
    description: "Description",
    id: "ID",
    invalidEmail: "Please enter a valid email address",
    invalidMaxUses: "Please enter a valid number of max uses",
    isRequired: "is required",
    back: "Back",
    notAvailable: "Not available",
    add: "Add",
    search: "Search...",
    noResultsFound: "No results found",
    save: "Save",
    remove: "Remove",
    view: "View",
    createdAt: "Created At",
    runTest: "Run Test",
    testing: "Testing",
    retry: "Retry",
    create: "Create",
  },
  invitations: {
    invitations: "Invitations",
    createInvitation: "Create Invitation",
    noInvitationsFound: "No invitations found.",
    loadingInvitations: "Loading invitations...",
    failedToLoadInvitations: "Failed to load invitations. Please try again.",
    failedToCreateInvitation: "Failed to create invitation. Please try again.",
    enterEmailAddress: "Enter email address",
    enterMaxUses: "Enter max uses (default: 1)",
    organization: "Organization",
    role: "Role",
    expiresIn: "Expires In",
    deleteInvitation: "Delete Invitation",
    deleteInvitationConfirm:
      "Are you sure you want to delete the invitation for",
    failedToDeleteInvitation: "Failed to delete invitation. Please try again.",
    invitationCreatedSuccess: "Invitation token created successfully!",
    yourToken: "Your Token",
    token: "Token",
    expiresAt: "Expires On",
    maxUses: "Max Uses",
    usageCount: "Times Used",
    createdBy: "Created By",
    day1: "1 Day",
    days3: "3 Days",
    days7: "7 Days",
    days30: "30 Days",
  },
  dashboard: {
    dashboard: "Dashboard",
    welcomeDashboard:
      "Welcome to your Grensa Dashboard. Manage your team, knowledge base, and settings.",
    manageTeam: "Manage Team",
    manageTeamDesc:
      "Invite and manage team members to collaborate on your knowledge base.",
    manageInvitations: "Manage Invitations",
    knowledgeBase: "Knowledge Base",
    knowledgeBaseDesc:
      "Add and manage your knowledge base sources for better customer support.",
    settings: "Settings",
    settingsDesc: "Configure your account settings and preferences.",
    comingSoon: "Coming Soon",
  },
  roles: {
    user: "User",
    admin: "Admin",
    superAdmin: "Super Admin",
  },
  organizations: {
    organizations: "Organizations",
    organization: "Organization",
    createOrganization: "Create Organization",
    editOrganization: "Edit Organization",
    updateOrganization: "Update Organization",
    noOrganizationsFound: "No organizations found.",
    loadingOrganizations: "Loading organizations...",
    failedToCreateOrganization: "Failed to create organization.",
    failedToUpdateOrganization: "Failed to update organization.",
    enterOrganizationName: "Enter organization name",
    enterOrganizationDescription: "Enter organization description",
    selectOrganization: "Select organization",
  },
  logs: {
    logs: "Logs",
    answers: "Answers",
    knowledgeBaseIngestions: "Knowledge Base Ingestions",
    answerId: "Answer ID",
    chatId: "Chat ID",
    userId: "User ID",
    userName: "User Name",
    orgName: "Organization",
    createdAt: "Created At",
    status: "Status",
    tokens: "Tokens",
    cost: "Cost",
    searchByAnswerId: "Search by answer ID",
    searchByUserEmail: "Search by user email",
    searchByOrganization: "Search by organization",
    searchMode: "Search Mode",
    filterOrganizations: "Filter organizations...",
    selectOrganization: "Select organization",
    resultsCount: "Results: {{count}}",
    noResults: "No results found",
    loading: "Loading...",
    ingestionId: "Ingestion ID",
    documentName: "Document Name",
    date: "Date",
    size: "Size",
    searchByDocumentName: "Search by document name",
    answerDetails: "Answer Details",
    answerDetailsPlaceholder: "Answer details will be displayed here",
    summary: "Summary",
    question: "Question",
    answer: "Answer",
    sources: "Sources",
    definition: "Definition",
    search: "Search",
    validation: "Validation",
    request: "Request",
    noConversationData: "No conversation data available",
    noSummary: "No summary available",
    noQuestion: "No question available",
    noAnswer: "No answer available",
    noSources: "No sources available",
    noError: "No error available",
    noStatus: "No status available",
    prompt: "Prompt",
    response: "Response",
    model: "Model",
    totalTokens: "Total Tokens",
    noLogData: "No log data available",
    promptTokens: "Prompt Tokens",
    completionTokens: "Completion Tokens",
    rawData: "Raw Data",
    formattedData: "Formatted Data",
    developer: "Developer",
    user: "User",
    language: "Language",
    relevantSections: "Relevant Sections",
    error: "Error",
    currentQuestion: "Current Question",
    clientQuestion: "Client Question",
    candidateQuestions: "Candidate Questions",
    conversation: "Conversation",
    product: "Product",
    macrosSuggestions: "Macros Suggestions",
    macros: "Macros",
    macroTitle: "Title",
    macroText: "Text",
    macroQuestions: "Questions",
    macroSimilarity: "Similarity",
    macroProduct: "Product",
    macroId: "Macro ID",
    selectedMacro: "Selected Macro",
    fromSearch: "from search",
    fromSuggestion: "from suggestions",
  },
  status: {
    successful: "Successful",
    unsuccessful: "Unsuccessful",
    undecided: "Undecided",
    completed: "Completed",
    failed: "Failed",
    pending: "Pending",
  },
  errors: {
    failedToFetchAnswers: "Failed to fetch answers. Please try again.",
    failedToFetchAnswerLogs: "Failed to fetch answer logs. Please try again.",
    failedToProcessData: "Failed to process data. Please try again.",
    failedToProcessLogs: "Failed to process log data. Please try again.",
    failedToGetAnswerId: "Failed to get answer ID from the response.",
    connectionError:
      "Connection error. Please check your connection and try again.",
    errorOccurred: "An error occurred",
    pageNotSupported: "This page type is not supported",
    noQuestion:
      "The client does not have any questions at the moment or all questions have already been answered.",
    noRelevantWikisError:
      "No relevant article found in the knowledge base. If necessary, add articles related to this chat to the knowledge base.",
  },
  pagination: {
    showing: "Showing {{from}} to {{to}} of {{total}} entries",
  },
  test: {
    testPage: "Testing",
    blockTestPage: "Block Testing",
    multiChatTestPage: "Multi-Chat Test",
    addClientMessage: "Add Client Message",
    addAgentMessage: "Add Agent Message",
    clientMessagePlaceholder: "Enter client message here...",
    agentMessagePlaceholder: "Enter support agent message here...",
    testAnswerGeneration: "Test Answer Generation",
    generateAnswer: "Generate Answer",
    clearConversation: "Clear Conversation",
    noMessagesToProcess:
      "No messages to process. Please add at least one message.",
    generatingAnswer: "Generating answer...",
    fetchingLogs: "Fetching logs data...",
    addNewChat: "Add New Chat",
    addFirstChat: "Add Your First Chat",
    chatName: "Chat Name",
    enterChatName: "Enter chat name",
    conversationMessages: "Conversation Messages",
    noChatsAdded:
      "No chats have been added yet. Start by adding your first chat.",
    runTest: "Run Test",
    runningTest: "Running test...",
    testCardName: "Test #{{number}}",
    createBlockTest: "Create Block Test",
    blockTestPageDescription:
      "Test multiple chats with different scenarios for an organization",
    createNewBlockTest: "Create New Block Test",
    noBlockTestsAvailable:
      "No block tests available. Start by creating your first test.",
    createFirstBlockTest: "Create Your First Block Test",
    blockTestName: "Block Test Name",
    enterBlockTestName: "Enter test name",
    testChats: "Test Chats",
    chatCount: "Chats",
    organization: "Organization",
    aiResponse: "AI Response",
    aiResponseError: "AI Response Error",
    noQuestionError:
      "Client doesn't have any questions at the moment or all questions are already addressed.",
    noRelevantWikisError:
      "Can't find an answer - there are no relevant wikis. Please add relevant to this chat wikis to the knowledge base.",
    genericServerError: "A server error occurred. Please try again later.",
    markSuccessful: "Mark as successful",
    markUnsuccessful: "Mark as unsuccessful",
    viewFullDetails: "View full details",
    resetTests: "Reset Tests",
    rerunTest: "Rerun Test",
    addMoreChats: "Add More Chats",
    confirmResetTests:
      "Are you sure you want to reset all tests? This will clear all chats and results.",
    viewBlockTest: "Block test #{{id}}",
    summary: "Response Summary",
    copyChatCard: "Copy Chat Card",
    numberOfCopies: "Number of copies to create",
  },
  validation: {
    chatNameRequired: "Chat name is required",
  },
};

export default enTranslations;
